export class BubblingMethod {

    public static isInsideOtherElement = (targetElement: HTMLElement, parentElement: HTMLElement): boolean => {
        if (targetElement === parentElement) {
            return true;
        }

        let bubble = targetElement.parentElement;

        while (bubble !== null && bubble !== parentElement) {
            bubble = bubble.parentElement;
        }

        return bubble === parentElement;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/common/helpers/bubbling.ts